type SearchClearButtonProps = {
  value: string;
  onClear: () => void;
};

export function SearchClearButton({ value, onClear }: SearchClearButtonProps) {
  if (value.length === 0) {
    return null;
  }

  return (
    <button
      type="button"
      className="hw-search-clear"
      aria-label="Очистить поиск"
      onClick={onClear}
    >
      <span aria-hidden="true">×</span>
    </button>
  );
}
